import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        loading: false,
        // baseurl: "https://www.greatamericandanos.mx/admin/",
        // homeurl: "https://www.greatamericandanos.mx/",
        baseurl: "https://phpstack-179665-2018465.cloudwaysapps.com/admin/",
        homeurl: "https://phpstack-179665-2018465.cloudwaysapps.com/",
        user: null,
        version: "v1.39"
    }
});